import React from 'react';
import styles from './InputArea.module.scss';
import { InputAreaProps } from './InputArea.type';
import { SuccessCheckIcon } from '@src/Components/Icons';

const CloseButton: React.FC<{ onClick: () => void }> = ({ onClick }) => (
  <button onClick={onClick} className={styles['CloseBtn']}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="General Function Icons">
        <g id="cancel">
          <mask
            id="mask0_564_75892"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <rect id="Bounding box" width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_564_75892)">
            <path
              id="cancel_2"
              d="M8.4 17L12 13.4L15.6 17L17 15.6L13.4 12L17 8.4L15.6 7L12 10.6L8.4 7L7 8.4L10.6 12L7 15.6L8.4 17ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
              fill="#E4E4E4"
            />
          </g>
        </g>
      </g>
    </svg>
  </button>
);

const CalendarIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="General Function Icons">
      <g id="calendar_month">
        <mask
          id="mask0_937_1185"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24"
        >
          <rect
            id="Bounding box"
            y="6.10352e-05"
            width="24"
            height="24"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_937_1185)">
          <path
            id="calendar_month_2"
            d="M12 14.0001C11.7167 14.0001 11.4792 13.9042 11.2875 13.7126C11.0958 13.5209 11 13.2834 11 13.0001C11 12.7167 11.0958 12.4792 11.2875 12.2876C11.4792 12.0959 11.7167 12.0001 12 12.0001C12.2833 12.0001 12.5208 12.0959 12.7125 12.2876C12.9042 12.4792 13 12.7167 13 13.0001C13 13.2834 12.9042 13.5209 12.7125 13.7126C12.5208 13.9042 12.2833 14.0001 12 14.0001ZM8 14.0001C7.71667 14.0001 7.47917 13.9042 7.2875 13.7126C7.09583 13.5209 7 13.2834 7 13.0001C7 12.7167 7.09583 12.4792 7.2875 12.2876C7.47917 12.0959 7.71667 12.0001 8 12.0001C8.28333 12.0001 8.52083 12.0959 8.7125 12.2876C8.90417 12.4792 9 12.7167 9 13.0001C9 13.2834 8.90417 13.5209 8.7125 13.7126C8.52083 13.9042 8.28333 14.0001 8 14.0001ZM16 14.0001C15.7167 14.0001 15.4792 13.9042 15.2875 13.7126C15.0958 13.5209 15 13.2834 15 13.0001C15 12.7167 15.0958 12.4792 15.2875 12.2876C15.4792 12.0959 15.7167 12.0001 16 12.0001C16.2833 12.0001 16.5208 12.0959 16.7125 12.2876C16.9042 12.4792 17 12.7167 17 13.0001C17 13.2834 16.9042 13.5209 16.7125 13.7126C16.5208 13.9042 16.2833 14.0001 16 14.0001ZM12 18.0001C11.7167 18.0001 11.4792 17.9042 11.2875 17.7126C11.0958 17.5209 11 17.2834 11 17.0001C11 16.7167 11.0958 16.4792 11.2875 16.2876C11.4792 16.0959 11.7167 16.0001 12 16.0001C12.2833 16.0001 12.5208 16.0959 12.7125 16.2876C12.9042 16.4792 13 16.7167 13 17.0001C13 17.2834 12.9042 17.5209 12.7125 17.7126C12.5208 17.9042 12.2833 18.0001 12 18.0001ZM8 18.0001C7.71667 18.0001 7.47917 17.9042 7.2875 17.7126C7.09583 17.5209 7 17.2834 7 17.0001C7 16.7167 7.09583 16.4792 7.2875 16.2876C7.47917 16.0959 7.71667 16.0001 8 16.0001C8.28333 16.0001 8.52083 16.0959 8.7125 16.2876C8.90417 16.4792 9 16.7167 9 17.0001C9 17.2834 8.90417 17.5209 8.7125 17.7126C8.52083 17.9042 8.28333 18.0001 8 18.0001ZM16 18.0001C15.7167 18.0001 15.4792 17.9042 15.2875 17.7126C15.0958 17.5209 15 17.2834 15 17.0001C15 16.7167 15.0958 16.4792 15.2875 16.2876C15.4792 16.0959 15.7167 16.0001 16 16.0001C16.2833 16.0001 16.5208 16.0959 16.7125 16.2876C16.9042 16.4792 17 16.7167 17 17.0001C17 17.2834 16.9042 17.5209 16.7125 17.7126C16.5208 17.9042 16.2833 18.0001 16 18.0001ZM5 22.0001C4.45 22.0001 3.97917 21.8042 3.5875 21.4126C3.19583 21.0209 3 20.5501 3 20.0001V6.00006C3 5.45006 3.19583 4.97923 3.5875 4.58756C3.97917 4.19589 4.45 4.00006 5 4.00006H6V2.00006H8V4.00006H16V2.00006H18V4.00006H19C19.55 4.00006 20.0208 4.19589 20.4125 4.58756C20.8042 4.97923 21 5.45006 21 6.00006V20.0001C21 20.5501 20.8042 21.0209 20.4125 21.4126C20.0208 21.8042 19.55 22.0001 19 22.0001H5ZM5 20.0001H19V10.0001H5V20.0001Z"
            fill="#E4E4E4"
          />
        </g>
      </g>
    </g>
  </svg>
);

const InputArea: React.FC<InputAreaProps> = ({
  label = 'Label',
  onClear,
  onChangeText,
  isError = false,
  messageErr,
  required,
  value,
  ...rest
}) => {
  const styleBorderLatLong =
    label === 'Latitude' || label === 'Longitude' ? 'location' : '';
  return (
    <div className={styles['Container']} data-testid="input-area">
      <span>
        {(label === 'Latitude' && !isError) ||
        (label === 'Longitude' && !isError) ? (
          <SuccessCheckIcon />
        ) : null}
        &nbsp;
        {label}
      </span>
      <div
        className={`${styles['InputContainer']} ${
          styles[`${isError ? 'error' : styleBorderLatLong}`]
        }`}
      >
        <input
          required={required}
          {...rest}
          value={value}
          onKeyUp={(e) => {
            if (onChangeText) {
              onChangeText(e.currentTarget.value);
            }
          }}
        />
        {rest.type === 'date' && (
          <span className={styles['open-button']}>
            <button type="button">
              <CalendarIcon />
            </button>
          </span>
        )}
        {onClear && <CloseButton onClick={onClear} />}
      </div>
      {isError && (
        <span className={styles['errors']}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M8.00017 9.33337C7.83535 9.33337 7.67423 9.38225 7.53719 9.47382C7.40015 9.56538 7.29334 9.69553 7.23027 9.84781C7.16719 10.0001 7.15069 10.1676 7.18284 10.3293C7.215 10.4909 7.29437 10.6394 7.41091 10.756C7.52745 10.8725 7.67594 10.9519 7.83759 10.984C7.99924 11.0162 8.1668 10.9997 8.31907 10.9366C8.47134 10.8735 8.60149 10.7667 8.69306 10.6297C8.78462 10.4926 8.8335 10.3315 8.8335 10.1667C8.8335 9.94569 8.7457 9.73373 8.58942 9.57745C8.43314 9.42117 8.22118 9.33337 8.00017 9.33337ZM8.00017 8.33337C8.17698 8.33337 8.34655 8.26314 8.47157 8.13811C8.59659 8.01309 8.66683 7.84352 8.66683 7.66671V5.66671C8.66683 5.4899 8.59659 5.32033 8.47157 5.1953C8.34655 5.07028 8.17698 5.00004 8.00017 5.00004C7.82335 5.00004 7.65379 5.07028 7.52876 5.1953C7.40374 5.32033 7.3335 5.4899 7.3335 5.66671V7.66671C7.3335 7.84352 7.40374 8.01309 7.52876 8.13811C7.65379 8.26314 7.82335 8.33337 8.00017 8.33337ZM8.00017 1.33337C6.68162 1.33337 5.39269 1.72437 4.29636 2.45691C3.20004 3.18945 2.34555 4.23064 1.84097 5.44882C1.33638 6.66699 1.20436 8.00744 1.4616 9.30064C1.71883 10.5938 2.35377 11.7817 3.28612 12.7141C4.21847 13.6464 5.40636 14.2814 6.69956 14.5386C7.99277 14.7958 9.33321 14.6638 10.5514 14.1592C11.7696 13.6547 12.8108 12.8002 13.5433 11.7038C14.2758 10.6075 14.6668 9.31858 14.6668 8.00004C14.6649 6.23253 13.9619 4.53796 12.7121 3.28814C11.4622 2.03832 9.76768 1.33532 8.00017 1.33337ZM8.00017 13.3334C6.94533 13.3334 5.91419 13.0206 5.03712 12.4345C4.16006 11.8485 3.47648 11.0156 3.07281 10.041C2.66914 9.06648 2.56352 7.99412 2.76931 6.95956C2.9751 5.92499 3.48305 4.97468 4.22893 4.2288C4.97481 3.48292 5.92512 2.97497 6.95968 2.76919C7.99425 2.5634 9.0666 2.66902 10.0411 3.07268C11.0157 3.47635 11.8486 4.15994 12.4347 5.037C13.0207 5.91406 13.3335 6.94521 13.3335 8.00004C13.3317 9.41399 12.7693 10.7695 11.7695 11.7693C10.7696 12.7691 9.41411 13.3316 8.00017 13.3334Z"
              fill="#B61733"
            />
          </svg>
          <div className={styles['ErrorMessage']}>{messageErr}</div>
        </span>
      )}
    </div>
  );
};

export default InputArea;
